module.exports = __webpack_public_path__ + "img/green.922458da.svg";